import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
let swiperInstances = [];

window.addEventListener('load', () => {
    handleSwiperInit();
});

window.addEventListener('resize', () => {
    handleSwiperInit();
});

function handleSwiperInit() {
    const isMobile = window.innerWidth <= 768;
    const blocks = document.querySelectorAll('.library-block');

    if (isMobile) {
        // If mobile and no swipers initialized, initialize them
        if (swiperInstances.length === 0) {
            blocks.forEach((block) => {
                const container = block.querySelector('.swiper');
                if (!container) return;

                const swiper = new Swiper(container, {
                    modules: [Navigation],
                    spaceBetween: 30,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: block.querySelector('.swiper-button-next'),
                        prevEl: block.querySelector('.swiper-button-prev'),
                    },
                    breakpoints: {
                        513: {
                            slidesPerView: 2,
                        },
                    },
                });
                swiperInstances.push(swiper);
            });
        }
    } else {
        // If desktop and swipers are initialized, destroy them
        if (swiperInstances.length > 0) {
            swiperInstances.forEach((swiper) => {
                if (typeof swiper.destroy === 'function') {
                    swiper.destroy(true, true);
                }
            });
            swiperInstances = [];
        }
    }
}
